<template>
  <main class="contenedor">
    <LoadingSpinner v-if="loadingOptionsList || loading" />
    <div class="row" v-if="!loadingOptionsList && !loading">
      <div class="col-md-12">
        <img
          src="@/assets/images/2.png"
          class="rounded mx-auto d-block"
          width="150px"
        />
        <h2 class="text-lg-center my-4">
          {{ $t("lang.appointments.commercialproposal") }}
        </h2>
        <h5 class="text-lg-center">{{ model.client.name }}</h5>
        <div v-if="!loading">
          <div
            v-if="alert.message && !submittedSecond"
            :class="`login-alert alert ${alert.type}`"
            v-html="alert.message"
          ></div>
        </div>
        <div class="float-right" v-if="model.client.id !== undefined && model.client.client_status_id != 6">
          <router-link :to="'/downgrade/'+model.client.id" class="btn btn-danger">DELETE</router-link>
        </div>
        <div class="float-right" v-if="model.client.id !== undefined && currentUser.role_id == 1 && model.client.hide != 1">
          <button @click.once="setAsFake()" class="btn btn-primary mr-3">SET AS FAKE ACCOUNT</button>
        </div>
         <div class="float-right" v-else-if="model.client.id !== undefined && currentUser.role_id == 1 && model.client.hide == 1">
          <button class="btn btn-primary mr-3" disabled>FAKE ACCOUNT</button>
        </div>
        <div>
          <Fieldset title="Client Info" :mykey="1232" :open="false">
            <vue-form-generator
              ref="clientForm"
              :schema="schemaClient"
              :model="this.model"
              :options="formOptions"
            ></vue-form-generator>
             <div class="form-group px-3 col-6" v-if="hasPermissions('superAdmin')">
             <label>{{ $t("lang.label.agencies")}}</label>
                <IndustrySearch
                  :option_list="model.agencies"
                  :default_values="model.client.agency"
                  :key="3"
                  >
                  <!-- :isDisabled="isDisable" -->
                </IndustrySearch>
             </div>
          </Fieldset>
        </div>
        <div>
          <Fieldset
          @opennow="openTarget=true;removeClass()"
          :title="$t('lang.orders.orders')" :mykey="344" :open="false">
          <div class="table-responsive">
            <Orders
              :fromClient="fromClient"
              :client_id="Number(selectedClientId)"/>
          </div>
          </Fieldset>
        </div>

        <Fieldset v-if="showAppointmentConfig" title="Appointment/Sales" :mykey="754" :open="false">
          <div class="row">
            <div class="col-md-12">
              <h4 class="mt-5">Appointment config</h4>
              <vue-form-generator
                ref="appointmentForm"
                :schema="schemaAppointment"
                :model="this.model"
                :options="formOptions"
              ></vue-form-generator>
            </div>
            <div class="col-md-12">
              <h4>
                <h4 class="mt-5 form-group required">
                  <label>Sales Reps</label>
                </h4>
                <span
                  class="badge badge-success cursor-pointer"
                  @click="openSalesRep(true)"
                >
                  <i class="icon-plus" v-if="!currentSalesRepWrapper"></i>
                </span>
              </h4>
              <div class="row" v-if="currentSalesRepWrapper">
                <div class="col-md-6" v-if="formOpen">
                  <div class="w-100">
                  <button
                    class="text-danger btn btn-disabled btn float-right mr-2 small"
                    @click="openSalesRep(false)"
                  >
                    <i class="icon-close mr-2"></i>{{ $t("lang.button.close") }}
                  </button>
                  </div>
                  <vue-form-generator
                    ref="salesRepForm"
                    :schema="schemaSalesRep"
                    :model="this.currentSalesRep"
                    :options="formOptions"
                  ></vue-form-generator>
                  <button
                    class="btn btn-success btn w-100"
                    @click="
                      addItem(
                        'model.salesRep',
                        'currentSalesRep',
                        'email',
                        'salesRepForm'
                      );

                      formOpen=false

                    "
                  >
                    <i class="icon-plus mr-2"></i>{{$t('lang.label.donefilter')}}
                  </button>
                </div>
              <div
                :class="formOpen ? 'col-md-6' : 'col-md-12'"
                class="card shadow p-4"
                v-if="
                  this.model.salesRep != undefined &&
                  this.model.salesRep.length > 0
                "
              >
                <Table
                    :headers="headersSalesRep"
                    :cols="colsSalesRep"
                    :data="model.salesRep"
                    :checkbox="false"
                    :notselect="true"
                    :myvalues="domain_config_values"
                    :model="model"
                    @editAnItem="editAnItem"
                    @removeAnItem="removeAnItem">
                </Table>
              </div>
                <button v-if="!formOpen && false" @click="openForm"
                class="btn btn-success">
                {{$t('lang.search.add')}}
                </button>
              </div>
            </div>
          </div>
        </Fieldset>
        <Fieldset v-if="false" title="Pitch/domain config" :mykey="56732" :open="false">
          <div class="row">
            <div class="col-md-12">
              <div class="field-ckeditor-wrappar" v-if="false">
                <ValidationProvider
                  ref="editorPitchV"
                  :rules="{
                    required: true,
                    'length-plain-text': [{ max: 750 }],
                  }"
                >
                  <div slot-scope="{ errors }">
                    <div
                      class="
                        form-group
                        valid
                        featured
                        required
                        field-input field-ckeditor
                      "
                      :class="
                        errors !== undefined && errors.length > 0 ? 'error' : ''
                      "
                    >
                      <label> {{ $t("lang.appointments.pitch") }}</label>
                      <div class="small">
                        {{ $t("lang.appointments.pitch_info") }}
                      </div>
                      <ckeditor
                        :editor="editorInitial"
                        v-model="editorPitch"
                        :config="editorConfig"
                      ></ckeditor>

                      <div class="errors help-block">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>

            <div class="col-md-12">
              <div class="field-ckeditor-wrappar">
                <ValidationProvider
                  ref="editorExtraInfoV"
                  :rules="{ 'length-plain-text': [{ max: 750 }] }"
                >
                  <div slot-scope="{ errors }">
                    <div
                      class="
                        form-group
                        valid
                        featured
                        field-input field-ckeditor
                      "
                      :class="
                        errors !== undefined && errors.length > 0 ? 'error' : ''
                      "
                    >
                      <label> {{ $t("lang.appointments.extrainfo") }}</label>
                      <div class="small">.</div>
                      <ckeditor
                        :editor="editorInitial"
                        v-model="editorExtraInfo"
                        :config="editorConfig"
                      ></ckeditor>

                      <div class="errors help-block">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <AgencyExtraForm
            :model="model"
            v-if="hasPermissionsAdminClients() && selectedClientId !== undefined"
          />
        </Fieldset>

        <div class="row">
          <div class="col-md-12 my-4">
            <button
              class="btn btn-success btn float-right"
              @click.once="setAgency()"
              :key="setAgencyKey"
            >
              {{ $t("lang.button.save") }}
            </button>

            <button
              class="btn btn-disabled btn float-right mr-2"
              @click="goBack()"
            >
              {{ $t("lang.button.cancel") }}
            </button>
          </div>
        </div>
        <div v-if="hasPermissionsAdminClients() && selectedClientId !== undefined">
           <Fieldset
            title="Team"
            :mykey="23232"
            :open="false"
            @opennow="activityopen = true"
          >
            <TableMonitor
              v-if="activityopen"
              :key="activityKey"
              :team_id="selectedClientId"
              :showOtherUsers="true"
              @refresh="refresh()"
            ></TableMonitor>
          </Fieldset>
        </div>
        <div v-if="hasPermissionsAdminClients() && selectedClientId !== undefined">
           <Fieldset
            title="Billing Dashboard"
            :mykey="54532"
            :open="false"
            @opennow="billingDashboardactive = true"
          >
            <InvoiceViewer :userId="model.user.id" v-if="billingDashboardactive"/>
          </Fieldset>
        </div>

        <div v-if="hasPermissionsAdminClients() && selectedClientId !== undefined">
          <Fieldset
            title="Billing"
            :mykey="493929112"
            :open="false"
            @opennow="billing = true"
          >
            <div class="mt-4">
              <BillingInfo :userId="model.user.id" v-if="billing" />
            </div>
          </Fieldset>

          <Fieldset
            title="Statistics"
            :mykey="34565675678"
            :open="false"
            @opennow="dashboardactive = true"
          >
            <DashboardAdmin
              v-if="dashboardactive"
              :clientId="selectedClientId"
            ></DashboardAdmin>
          </Fieldset>
          <Fieldset
            title="Excluded domains"
            :mykey="3432565675678"
            :open="false"
          >
            <AgencyImportExcludeDomains :clientId="selectedClientId" />
          </Fieldset>
          <Fieldset
            title="Notifications"
            :mykey="3432565675611"
            :open="false"
          >
          <div class="row">
            <div class="col-12">
              <ListNotifications
              :clientId="Number(selectedClientId)"/>
            </div>
          </div>
          </Fieldset>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TargetModal from "@/components/Onboarding/TargetsModal.vue";
import AlertError from "@/components/AlertError.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import Fieldset from "@/components/Common/Fieldset.vue";
import { lenguagesService, clientsService, targetsService } from "@/_services";
import VueFormGenerator from "vue-form-generator";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import EmployeeSearch from "@/components/AccountCreation/Steps/Campaign/search/EmployeeSearch.vue";
import PopupItem from "@/components/AccountCreation/Steps/Campaign/search/Popup-item.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";
import AgencyExtraForm from "./AgencyExtraForm.vue";
import BillingInfo from "@/components/Users/BillingInfo.vue";
import ClientTeam from "@/components/Account/ClientTeam.vue";
import { itemsMixin } from "@/_mixins/";
import TableMonitor from "@/components/Dashboard/Monitor/Table.vue";
import Table from "@/components/Common/Table.vue";
import DashboardAdmin from "@/components/Dashboard/DashboardAdmin.vue";
import AgencyImportExcludeDomains from "@/components/Agencies/AgencyImportExcludeDomains.vue";
import ListNotifications from "@/components/Account/ListNotifications.vue";

import TargetsView from "@/components/Agencies/TargetsView.vue";
import Orders from "../Onboarding/Orders.vue";
import InvoiceViewer from "@/components/Common/InvoiceViewer.vue";


export default {
  props: {
    selectedClientId: String,
  },
  mixins: [itemsMixin],
  data() {
    var self = this;
    return {
      fromClient: true,
      showAppointmentConfig: false,
      salesRepList:[],
      formOpen:false,
      activityKey:222,
      headersSalesRep:[
          {
          'label' : this.$t('lang.label.name'),
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : this.$t('lang.label.lastname'),
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : this.$t('lang.label.email'),
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : this.$t('lang.label.phone'),
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : this.$t('lang.search.linkedin'),
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : this.$t('lang.label.domain'),
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : "Calendly url",
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : "Landing Page",
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : "Calendly token",
          'percentage':'20%',
          'class':'overflowhide'
          },
          {
          'label' : '',
          'percentage':'10%',
          'class':'overflowhide'
          },
          {
          'label' : '',
          'percentage':'10%',
          'class':'overflowhide'
          },
      ],
      colsSalesRep:[
          [{
          'value' : 'first_name'
          }],
          [{
          'value' : 'last_name'
          }],
          [{
          'value' : 'email'
          }],
          [{
          'value' : 'phone'
          }],
          [{
          'value' : 'linkedinurl'
          }],
          [{
          'value' : 'workspace_domain_id',
          'getvalue' : true
          }],
          [{
          'value' : 'landing_link'
          }],
          [{
          'value' : 'calendar_link'
          }],
          [{
          'value' : 'calendly'
          }],
          /*[{
            'label' : this.$t('lang.label.edit'),
            'value_emit' : 'index',
            'class' : 'text-primary',
            'type':'emit',
            'icon':'icon-edit',
            'emit': 'editAnItem'
          }],
          [{
            'label' : this.$t('lang.label.remove'),
            'value_emit' : 'index',
            'class' : 'text-danger',
            'type':'emit',
            'icon':'icon-trash',
            'emit': 'removeAnItem'
          }],*/
      ],
      openTarget:false,
      targetsKey: 32432320,
      workspace_domain_id:false,
      domain_config_values:[],
      targetdata: false,
      activityopen: false,
      dashboardactive: false,
      billingDashboardactive: false,
      team: false,
      billing: false,
      loading: true,
      setAgencyKey: 0,
      currentSalesRepWrapper: true,
      keywordscant: 0,
      currentTarget: {
        name: "",
        appt_quantity:"",
        launch_date_campaign:"",
        data: {
          categories_industry: [],
          employees: {},
          categories_level: [],
          categories_function: [],
          categories_jobs: {},
          region: [],
          countries: [],
        },
      },
      currentTargetKey: 0,
      currentTargetInit: {
        name: "",
        appt_quantity:"",
        launch_date_campaign:"",
        data: {
          categories_industry: [],
          employees: {},
          categories_level: [],
          categories_function: [],
          categories_jobs: {},
          region: [],
          countries: [],
        },
      },
      targetsLength: 0,
      schemaClient: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.firstname"),
            model: "user.name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.name"),
            model: "user.lastname",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "select",
            label: this.$t("lang.label.language"),
            model: "user.language_id",
            readonly: false,
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
            selectOptions: {},
            values: () => {
              return self.langs.data;
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.company"),
            model: "client.name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "user.email",
            featured: true,
            readonly: false,
            required: true,
            disabled() {
              return !self.hasPermissions('adminClients');
            },
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "emailValidator",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.phone"),
            model: "user.phone",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.address"),
            model: "client.address",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "SIRET",
            model: "client.siret",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 100,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.website"),
            model: "client.website",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 255,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "password",
            label: this.$t("lang.label.password"),
            model: "user.password",
            featured: true,
            required() {
              return self.selectedClientId === undefined;
            },
            validator(value, field, model) {
              if (
                self.selectedClientId === undefined ||
                (self.selectedClientId !== undefined &&
                  value != undefined &&
                  value != "")
              ) {
                return VueFormGenerator.validators.validatePassword(
                  value,
                  field,
                  model
                );
              }
              return [];
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "date",
            label: this.$t("lang.appointments.signatureexpirationdate"),
            model: "client.signature_expiration_date",
            readonly: false,
            featured: true,
            required: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            visible() {
              return self.hasPermissions('adminClients');
            },
            format: "YYYY-MM-DD",
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "select",
            label: this.$t("lang.label.accountmanager"),
            model: "client.accountManager",
            readonly: false,
            featured: true,
            visible() {
              return  self.hasPermissions("adminAgency");
            },
            validator: VueFormGenerator.validators.required,
            values: () => {
              return this.model.usersAm
            },
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "datetime",
            label: this.$t("lang.appointments.signedon"),
            model: "client.signed_on",
            readonly: false,
            featured: true,
            required: false,
            validator: [VueFormGenerator.validators.date],
            visible() {
              return (
                self.hasPermissions('adminClients') &&
                (self.model_init.client.signed_on === undefined ||
                  self.model_init.client.signed_on === null)
              );
            },
            format: "YYYY-mm-dd H:i:s",
            hint: this.$t("lang.appointments.signedonhint"),
            styleClasses: "col-md-6 display-inline",
          },
        ],
      },
      schemaSalesRep: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true,
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.name"),
            model: "first_name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.lastname"),
            model: "last_name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "email",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required"),
              }),
              "emailValidator",
            ],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.phone"),
            model: "phone",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-3",
          },
          {
            type: "select",
            inputType: "number",
            label: this.$t("lang.label.domain"),
            model: "workspace_domain_id",
            readonly: false,
            featured: true,
            visible() {
              return self.hasPermissions("adminClients");
            },
            validator: VueFormGenerator.validators.required,
            values: () => {
              return this.domain_config_values
            },
            styleClasses: "col-md-3",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.search.linkedin"),
            model: "linkedinurl",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.url.locale({
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{20}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: 'Calendly Url',
            model: "calendar_link",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.url.locale({
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{20}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: 'Landing Page Url',
            model: "landing_link",
            featured: true,
            readonly: false,
            disabled: false,
            min: 5,
            max: 50,
            validator: VueFormGenerator.validators.url.locale({
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{20}",
              }),
            }),
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "text",
            label: "Calendly Token",
            model: "calendly",
            featured: true,
            readonly: false,
            disabled: false,
            min: 3,
            max: 50,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            styleClasses: "col-md-6",
          },
        ],
      },
      schemaTarget: {
        fields: [
          {
            type: "input",
            inputType: "text",
            model: "name",
            required: true,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
          },
          {
            type: "select",
            label: this.$t("lang.label.status"),
            model: "target_status_id",
            featured: true,
            required: true,
            values: function () {
              return [
                { id: "1", name: this.$t("lang.targets.active") },
                { id: "2", name: this.$t("lang.targets.stopped") },
              ];
            },
            default: "1",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.quantity"),
            model: "appt_quantity",
            readonly: false,
            disabled: false,
            min: 5,
            max: 10000,
            validator: ["numberBetweenValidator"],
            styleClasses: "",
          },
          {
            type: "input",
            inputType: "date",
            label: this.$t("lang.onBoarding.launch_date_campaign"),
            model: "launch_date_campaign",
            readonly: false,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            format: "YYYY-MM-DD",
          },
        ],
      },
      schemaEmployees: {
        fields: [
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.morethan"),
            model: "data.employees.keywords.greater",
            min: 0,
            max: 100000,
            required: false,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.label.lessthan"),
            model: "data.employees.keywords.less",
            min: 0,
            max: 100000,
            required: false,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6",
          },
        ],
      },
      schemaAppointment: {
        fields: [
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.quantity"),
            model: "client.appt_quantity",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 10000,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "select",
            label: this.$t("lang.appointments.duration"),
            model: "client.appt_duration",
            readonly: false,
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
            values: [
              { id: 15, name: "15 " + this.$t("lang.label.minutes") },
              { id: 30, name: "30 " + this.$t("lang.label.minutes") },
              { id: 45, name: "45 " + this.$t("lang.label.minutes") },
              { id: 60, name: "60 " + this.$t("lang.label.minutes") },
            ],
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.appointments.outreachdomain"),
            model: "client.outreach_domain",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 3,
            max: 255,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}",
              }),
            }),
            hint: "&lt;your-domain&gt;-pro.com",
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "date",
            label: this.$t("lang.appointments.startdate"),
            model: "client.appt_start_date",
            readonly: false,
            featured: true,
            required: true,
            validator: [
              VueFormGenerator.validators.required,
              VueFormGenerator.validators.date,
            ],
            // set: function(model, val) {
            //   model.client.appt_start_date = new Date(val).valueOf();
            // },
            format: "YYYY-MM-DD",
            // dateTimePickerOptions: {
            //   format: "YYYY-MM-DD HH:ii:ss",
            // },
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "select",
            label: this.$t("lang.appointments.synccrm"),
            model: "client.sync_crm",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            values: [
              { id: 1, name: this.$t("lang.button.yes") },
              { id: 0, name: this.$t("lang.label.no") },
            ],
            styleClasses: "col-md-6 display-inline",
          },
          {
            type: "input",
            inputType: "number",
            label: this.$t("lang.appointments.meetingprice") + " (€ H.T)",
            model: "client.meeting_price",
            featured: true,
            readonly: false,
            required: true,
            visible: false,
            disabled() {
              return !self.hasPermissions("adminClients");
            },
            min: 1,
            max: 10000,
            validator: ["numberBetweenValidator"],
            styleClasses: "col-md-6 display-inline",
          },
        ],
      },
      editorInitial: ClassicEditor,
      editorPitch: "",
      editorExtraInfo: "",
      editorConfig: {
        toolbar: ["heading", "|", "bold", "italic", "|", "link"],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      model_empty: { client: {}, user: {} },
      model: {},
      model_init: {},
      currentSalesRep: {},
      usersAm:[],
    };
  },
  components: {
    TargetModal,
    AlertError,
    ckeditor: CKEditor.component,
    IndustrySearch,
    EmployeeSearch,
    Table,
    PopupItem,
    LoadingSpinner,
    KeyWordSearch,
    AgencyExtraForm,
    BillingInfo,
    ClientTeam,
    Fieldset,
    TableMonitor,
    DashboardAdmin,
    AgencyImportExcludeDomains,
    TargetsView,
    Orders,
    InvoiceViewer,
    ListNotifications
},
  computed: {

    ...mapState({
      currentUser: (state) => state.authentication.user,
      loadingOptionsList: (state) => !state.optionsList.completeLoadingAgency,
      langs: (state) => state.optionsList.all["languages"],
      hierarchyoptions: (state) => state.optionsList.all["regions"].data,
      hierarchyoptionsSearch: (state) =>
        state.optionsList.all["categories_search_words"].data,
      hierarchyoptionsSearchFunction: (state) =>
        state.optionsList.all["categories_search_function"].data,
      hierarchyoptionsSearchLevel: (state) =>
        state.optionsList.all["categories_search_level"].data,
      hierarchyoptionsGoogle: (state) =>
        state.optionsList.all["categories_google"].data,
      companySizeOptions: (state) => state.optionsList.all["param_5"].data,
      hierarchyoptionsGoogleAll: (state) =>
        state.optionsList.all["categories_google_all"].data,
      hierarchyoptionsCountry: (state) =>
        state.optionsList.all["countries"].data,
    }),
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    alert() {
      return this.$store.state.alert;
    },
    agencyFormValidate() {
      // this.$refs.clientForm.validate();
      // this.$refs.appointmentForm.validate();
      // this.$refs.editorExtraInfoV.validate();
      // if (
      //   (this.$refs.clientForm.errors !== undefined &&
      //     this.$refs.clientForm.errors.length > 0) ||
      //   (this.$refs.appointmentForm.errors !== undefined &&
      //     this.$refs.appointmentForm.errors.length > 0) ||
      //   (this.$refs.editorExtraInfoV.errors !== undefined &&
      //     this.$refs.editorExtraInfoV.errors.length > 0) ||
      //   (this.model.targets !== undefined && this.model.targets.length == 0) ||
      //   (this.model.salesRep !== undefined && this.model.salesRep.length == 0)
      // ) {
      //   return false;
      // }
      return true;
    },
  },
  created() {


    this.getAgency();
    this.getAllOptionsList();

    this.$emit("loadingFinish");
  },
  methods: {
    ...mapActions("optionsList", {
      getAllOptionsList: "getAllAgencyParams",
    }),
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    setAsFake(){
      this.loading = true;
      clientsService
        .setParameters({
          id: this.selectedClientId,
          hide: 1
        })
      .then((result) => {
        this.model.client.hide = 1;
        this.loading = false;
        return;
      });
    },
    refresh(){
      this.activityKey++
    },
    openForm(){
      this.formOpen=true;
      this.currentSalesRep = {};
    },
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    hasPermissionsAdminClients() {
      return this.hasPermissions('adminClients');
    },
    getApollo(data) {
      this.targetdata = false;
      targetsService.getApollo(data).then((response) => {
        console.log(response)
        let apollo =  {
              people: [],
              total_result: 0,
         };
         apollo.people = response.people;
         apollo.total_result = response.pagination.total_entries
        this.targetdata = apollo;
        this.openModal("target");
      });
    },
    editItemTarget(model, index, current){
      this.openModal("targetedit")
      this.editItem(model, index, current)
    },
    editAnItem(index){
      this.formOpen = true
      this.editItem('model.salesRep', index, 'currentSalesRep')
    },
    removeAnItem(index){
      this.removeItem('model.salesRep', index)
    },
    openModal(name) {
      this.$modal.show(name);
    },
    closeModal(name) {
      this.$modal.hide(name);
    },
    updateCant(cant) {
      this.keywordscant = cant;
    },
    copyItem(index) {
      var newtarget = JSON.parse(JSON.stringify(this.model.targets[index]));
      newtarget.id = null;
      this.model.targets[this.model.targets.length] = newtarget;
      this.targetsKey++;
     // this.$forceUpdate();
    },
    openSalesRep(open) {
      this.formOpen=open
    },
    addTarget() {

      this.$refs.targetForm.validate();
      this.$refs.employeesForm.validate();
      // custom validation
      if (
        (this.$refs.targetForm.errors !== undefined &&
          this.$refs.targetForm.errors.length > 0) ||
        (this.$refs.employeesForm.errors !== undefined &&
          this.$refs.employeesForm.errors.length > 0) ||
        ((this.currentTarget.data.employees === undefined ||
          this.currentTarget.data.employees.keywords === undefined ||
          this.currentTarget.data.employees.keywords.greater === undefined) &&
          (this.currentTarget.data.employees === undefined ||
            this.currentTarget.data.employees.keywords === undefined ||
            this.currentTarget.data.employees.keywords.less === undefined) &&
          (this.currentTarget.data.categories_industry === undefined ||
            this.currentTarget.data.categories_industry.length == 0) &&
          (this.currentTarget.data.region === undefined ||
            this.currentTarget.data.region.length == 0) &&
          (this.currentTarget.data.categories_level === undefined ||
            this.currentTarget.data.categories_level.length == 0) &&
          (this.currentTarget.data.categories_function === undefined ||
            this.currentTarget.data.categories_function.length == 0) &&
          (this.currentTarget.data.countries === undefined ||
            this.currentTarget.data.countries.length == 0))
      ) {
        return;
      }
      this.closeModal('targetedit');
      this.addItem(
        "model.targets",
        "currentTarget",
        "name",
        "targetForm,employeesForm"
      );
      this.targetsKey++
    },
    setAgency() {
      if (!this.agencyFormValidate) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.missingdata"),
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.ok"),
        });
        this.setAgencyKey++;
        return;
      }
      this.loading = true;
      const data = {
        user: this.model.user,
        client: this.model.client
      }
      clientsService
        .setAgency(data)
        .then((response) => {
          if(this.selectedClientId === undefined){
            this.selectedClientId = response;
          }
          this.getAgency();
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.datasavedsuccessfully"),
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33a2c",
            confirmButtonText: this.$t("lang.button.ok"),
          });
          this.loading = false;
        })
        .catch((err) => {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33a2c",
            confirmButtonText: this.$t("lang.button.ok"),
          });
          this.setAgencyKey++;
          this.loading = false;
        });
    },
    getAgency() {
      //this.model = this.model_empty;
      //this.model_init = this.model;
      this.loading = true;

      if (this.selectedClientId !== undefined) {
        if (this.selectedClientId != undefined) {
          clientsService.getAgency(this.selectedClientId).then((response) => {
            this.model = response;

            this.model.client.domain_config.forEach((domain) => {
                this.domain_config_values.push({
                  id:domain.id,
                  name:domain.domain,
                })
            })
            if(this.model.client.accountManager != null){
              this.model.client.hasAccountManager = this.model.client.accountManager
            } else {
              this.model.client.hasAccountManager = null
              this.model.client.accountManager = null
            }
            if (
              this.model.salesRep !== undefined &&
              this.model.salesRep !== null
            ) {
              this.model.salesRep.forEach((sales) => {
                    this.salesRepList.push({'id':sales.id,
                                            'label':sales.first_name+' '+sales.last_name})
              });
            }

            if (
              this.model.targets !== undefined &&
              this.model.targets !== null
            ) {
              this.model.targets.forEach((target) => {
                // convert empty array into object
                if (Array.isArray(target.data.employees)) {
                  target.data.employees = {};
                }
                if (
                  target.data.categories_jobs === undefined ||
                  Array.isArray(target.data.categories_jobs)
                ) {
                  target.data.categories_jobs = {};
                }
              });
            }
            if (
              this.model.client.pitch !== undefined &&
              this.model.client.pitch !== null
            ) {
              this.editorPitch = this.model.client.pitch;
            }
            if (
              this.model.client.extra_info !== undefined &&
              this.model.client.extra_info !== null
            ) {
              this.editorExtraInfo = this.model.client.extra_info;
            }
            if (
              this.model.client.signed_on !== undefined &&
              this.model.client.signed_on !== null
            ) {
              this.model.client.signed_on = this.model.client.signed_on
                .replace(" ", "T")
                .substring(0, 16);
            }
            this.model_init = JSON.parse(JSON.stringify(this.model));
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
    goBack() {
      if (this.hasPermissions("adminClients")) {
        this.changeHeaderTab({ tab: "ALL" });
      } else {
        this.$router.push("/contract");
      }
    },
    removeClass(){
      // let element = document.getElementById('orders')
      // let myElement = element.getElementsByClassName('main')
      // myElement[0].classList.remove('main')
    },
  },
  watch: {
    editorPitch: function () {
      this.model.client.pitch = this.$sanitize(this.editorPitch);
    },
    editorExtraInfo: function () {
      this.model.client.extra_info = this.$sanitize(this.editorExtraInfo);
    },
  },
};
</script>
<style scoped>
@media(min-width:990px){
  .main{
    margin-left: 150px !important;
  }
}
.display-inline label,
.display-inline .field-wrap {
  width: 50%;
  float: left;
}

.display-inline label {
  text-align: right;
  padding-right: 10px;
  min-height: 50px;
}

.display-inline .errors,
.display-inline .hint {
  width: 50%;
  float: right;
  padding-left: 2px;
}
</style>
